import { RouterPage } from 'lib/navigation/consts'

interface Params {
  search?: string
}

/**
 * When businessId is provided, returns the root path to the business.
 * Otherwise returns the root path of the app
 */
export const getBusinessRootPath = (businessId: Maybe<string>, params: Params = {}) => {
  const path = businessId ? `/${businessId}` : RouterPage.root

  return path + (params.search ? `?${params.search}` : '')
}
